export enum CollectionPageType {
  ITEMS = "items",
  MY_ITEMS = "my itmes",
  ACTIVITY = "activity",
  OFFERS = "offers",
}
